<template>
  <!-- TODO: 增加设置登录状态，支持登录之后默认不接待状态 -->
  <div id="bd-login">
    <el-main>
      <el-row>
        <el-col :span="8"><div class="grid-content"></div></el-col>
        <el-col :span="8">
          <div class="top">
            <div class="header">
              <a
                href="https://www.weikefu.net/"
                target="_blank"
                style="text-decoration: none;"
              >
                <img
                  src="https://www.weikefu.net/assets/icon/256.png"
                  class="vlogo"
                  alt="logo"
                />
                <span class="title">{{ $t("bytedesk") }}</span>
              </a>
            </div>
            <div class="desc">
              {{ $t("customerServiceMoreEfficient") }}
            </div>
          </div>
        </el-col>
        <el-col :span="8"></el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><div class="grid-content"></div></el-col>
        <el-col :span="9">
          <el-radio-group
            v-model="currentLang"
            @change="onLangChange"
            size="mini"
          >
            <el-radio-button label="中文"></el-radio-button>
            <el-radio-button label="English"></el-radio-button>
          </el-radio-group>
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            style="margin-top: 15px;"
          >
            <el-tab-pane style="margin-top: 15px;" :label="subDomainLoginTip" name="first">
              <el-form
                :model="loginForm"
                status-icon
                :rules="rules"
                ref="loginForm"
                label-width="120px"
              >
                <el-form-item :label="subDomainTip" prop="sub_domain">
                  <el-input
                    v-model="loginForm.sub_domain"
                    :placeholder="mustTip"
                    style="width: 250px;"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item :label="emailUsernameTip" prop="email">
                  <el-input
                    v-model="loginForm.email"
                    :placeholder="emailTip"
                    style="width: 250px;"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item :label="passwordTip" prop="password">
                  <el-input
                    type="password"
                    show-password
                    v-model="loginForm.password"
                    @keyup.enter.native="onEnter"
                    auto-complete="off"
                    :placeholder="passwordTip"
                    style="width: 250px;"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    v-model="rememberPassword"
                    @change="handleRememberPasswordChange"
                    >{{ $t("rememberPassword") }}</el-checkbox
                  >
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="login"
                    :loading="logining"
                    >{{ $t("login") }}</el-button
                  >
                  <el-button type="text" @click="handleRegister">{{
                    $t("register")
                  }}</el-button>
                  <el-button type="text" @click="handleDownload">{{
                    $t("download")
                  }}</el-button>
                  <p>{{ $t("noteNoNeedSubdomain") }}</p>
                  <p v-if="!electron">
                    <span
                      ><a
                        href="http://www.51xiazai.cn/soft/4782.htm"
                        target="_blank"
                        style="color: #FF0000;"
                        >请使用谷歌浏览器</a
                      ></span
                    >
                  </p>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane style="margin-top: 15px;" :label="passwordLoginTip" name="second">
              <el-form
                :model="loginForm"
                status-icon
                :rules="rules"
                ref="loginForm"
                label-width="100px"
              >
                <el-form-item :label="emailMobileTip" prop="email">
                  <el-input
                    v-model="loginForm.email"
                    :placeholder="emailTip"
                    style="width: 250px;"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item :label="passwordTip" prop="password">
                  <el-input
                    type="password"
                    show-password
                    v-model="loginForm.password"
                    @keyup.enter.native="onEnter"
                    auto-complete="off"
                    :placeholder="passwordTip"
                    style="width: 250px;"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    v-model="rememberPassword"
                    @change="handleRememberPasswordChange"
                    >{{ $t("rememberPassword") }}</el-checkbox
                  >
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="login"
                    :loading="logining"
                    >{{ $t("login") }}</el-button
                  >
                  <el-button type="text" @click="handleRegister">{{
                    $t("register")
                  }}</el-button>
                  <el-button type="text" @click="handleDownload">{{
                    $t("download")
                  }}</el-button>
                  <p v-if="!electron">
                    <span
                      ><a
                        href="http://www.51xiazai.cn/soft/4782.htm"
                        target="_blank"
                        style="color: #FF0000;"
                        >请使用谷歌浏览器</a
                      ></span
                    >
                  </p>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane style="margin-top: 15px;" :label="smsLoginTip" name="third">
              <el-form
                :model="smsForm"
                status-icon
                :rules="smsRules"
                ref="smsForm"
                label-width="100px"
              >
                <el-form-item :label="mobileTip" prop="mobile">
                  <el-input
                    v-model="smsForm.mobile"
                    :placeholder="mobileTip"
                    style="width: 250px;"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item :label="smsCodeTip" prop="code">
                  <el-input
                    v-model="smsForm.code"
                    @keyup.enter.native="smsEnter"
                    auto-complete="off"
                    :placeholder="smsCodeTip"
                    style="width: 150px;"
                    clearable
                  ></el-input>
                  <el-button @click="sendSmsCode" :loading="sending">{{
                    $t("smsCode")
                  }}</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="smsLogin"
                    :loading="logining"
                    >{{ $t("login") }}</el-button
                  >
                  <el-button type="text" @click="handleRegister">{{
                    $t("register")
                  }}</el-button>
                  <el-button type="text" @click="handleDownload">{{
                    $t("download")
                  }}</el-button>
                  <p v-if="!electron">
                    <span
                      ><a
                        href="http://www.51xiazai.cn/soft/4782.htm"
                        target="_blank"
                        style="color: #FF0000;"
                        >请使用谷歌浏览器</a
                      ></span
                    >
                  </p>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="8"><div class="grid-content"></div></el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import * as https from "@/apis/http";
import bus from "@/util/eventbus";
import Vue from "vue";
const constants = require("@/util/constants");

export default {
  name: "bd-login",
  data() {
    return {
      activeName: "first",
      errorCode: 0,
      is400: false,
      isIp: constants.IS_IP,
      // 是否记住密码
      rememberPassword: true,
      // 是否登录中
      logining: false,
      // 验证码发送中
      sending: false,
      loginForm: {
        sub_domain: "",
        email: "",
        password: "",
      },
      smsForm: {
        mobile: "",
        code: "",
      },
      rules: {
        // sub_domain: [
        //   { required: true, message: '请输入企业号', trigger: 'blur' }
        // ],
        email: [
          { required: true, message: "请输入用户名/邮箱", trigger: "blur" },
          // { type: 'email', message: '请输入正确的邮箱地址', trigger: 'change' },
          { min: 5, message: "长度不能少于5个字符", trigger: "blur" },
          // TODO: 此处增加验证用户账号是否已经被禁用，如已禁用，则禁止登录
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      smsRules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "长度必须为11", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 6, max: 6, message: "长度必须为6", trigger: "blur" },
        ],
      },
      currentLang: "zh",
      title: constants.DEFAULT_TITLE,
      electron: constants.IS_ELECTRON,
    };
  },
  computed: {
    // ...mapGetters([ 'mainHost' ]),
    subDomain() {
      // 如果包含二级域名，那么返回二级域名，否则返回空
      return location.hostname.split(".").length > 2
        ? location.hostname.split(".")[0]
        : "";
    },
    subDomainLoginTip() {
      return this.$t("subDomainLogin");
    },
    subDomainTip() {
      return this.$t("subDomain");
    },
    emailTip() {
      return this.$t("email");
    },
    emailUsernameTip() {
      return this.$t("email/username");
    },
    passwordLoginTip() {
      return this.$t("passwordLogin");
    },
    smsLoginTip() {
      return this.$t("smsLogin");
    },
    passwordTip() {
      return this.$t("password");
    },
    emailMobileTip() {
      return this.$t("email/mobile");
    },
    mobileTip() {
      return this.$t("mobile");
    },
    smsCodeTip() {
      return this.$t("smsCode");
    },
    optionalTip() {
      return this.$t("optional");
    },
    mustTip() {
      return this.$t("musttip")
    }
  },
  methods: {
    ...mapActions(["updatePassportToken", "updateLogin", "loginSuccess"]),
    handleClick(tab, event) {
      // console.log(tab, event)
      this.activeName = tab.name;
      // console.log(this.activeName)
    },
    handleRememberPasswordChange(value) {
      // console.log('handleRememberPasswordChange:', value)
      if (!value) {
        // 不记住密码，则清空本地缓存
        this.loginForm.sub_domain = "";
        this.loginForm.email = "";
        this.loginForm.password = "";
        //
        Vue.ls.set(constants.SUBDOMAIN, this.loginForm.sub_domain);
        Vue.ls.set(constants.EMAIL, this.loginForm.email);
        Vue.ls.set(constants.PASSWORD, this.loginForm.password);
      }
    },
    onEnter() {
      this.login();
    },
    login() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          let username = this.loginForm.email.toLowerCase();
          // 判断是否是email，如果不是email，则添加后缀 ‘@subDomain’
          if (username.indexOf("@") < 0 && this.activeName === "first") {
            username = username + "@" + this.loginForm.sub_domain;
          }
          this.logining = true;
          https.login(
            username,
            this.loginForm.password,
            (response) => {
              // console.log('login success:', response)
              this.logining = false;
              if (response === null || response === undefined) {
                if (this.errorCode === 500) {
                  return;
                }
                if (!this.is400) {
                  // 非400错误的情况下，才会显示超时
                  bus.$emit(constants.EVENT_BUS_LOGIN_TIMEOUT, "");
                }
                return;
              }
              // Electron 显示tray图标
              if (constants.IS_ELECTRON) {
                ipcRenderer.send("show-tray", "");
              }
              // 务必设置一下
              localStorage.access_token = response.access_token;
              this.updatePassportToken(response);
              // 统一antv管理后台方式
              Vue.ls.set(
                constants.ACCESS_TOKEN,
                response.access_token,
                7 * 24 * 60 * 60 * 1000
              );
              // 存储企业号
              if (this.rememberPassword) {
                Vue.ls.set(constants.SUBDOMAIN, this.loginForm.sub_domain);
                Vue.ls.set(constants.EMAIL, this.loginForm.email);
                Vue.ls.set(constants.PASSWORD, this.loginForm.password);
              }
              // 登入更新状态
              // 客服端登录成功之后，推送到公众号提示用户已经登录
              this.updateLogin();
              // 客服端登录成功之后，推送到公众号提示用户已经登录
              // this.loginSuccess();
              // 跳转管理后台
              this.$router.replace("/admin");
            },
            (error) => {
              console.log("login error:", error);
              this.logining = false;
            }
          );
        } else {
          return false;
        }
      });
    },
    smsEnter() {
      this.smsLogin();
    },
    smsLogin() {
      if (this.smsForm.mobile.length !== 11 || this.smsForm.code.length !== 6) {
        this.$message.error(this.$t("mobileOrCodeError"));
        return;
      }
      this.logining = true;
      https.smsLogin(
        this.smsForm.mobile,
        this.smsForm.code,
        (response) => {
          // console.log('login success:', response)
          this.logining = false;
          if (response === null || response === undefined) {
            if (this.errorCode === 500) {
              return;
            }
            if (!this.is400) {
              // 非400错误的情况下，才会显示超时
              bus.$emit(constants.EVENT_BUS_LOGIN_TIMEOUT, "");
            }
            return;
          }
          // Electron 显示tray图标
          if (constants.IS_ELECTRON) {
            ipcRenderer.send("show-tray", "");
          }
          // 务必设置一下
          localStorage.access_token = response.access_token;
          this.updatePassportToken(response);
          // 统一antv管理后台方式
          Vue.ls.set(
            constants.ACCESS_TOKEN,
            response.access_token,
            7 * 24 * 60 * 60 * 1000
          );
          // 登入更新状态
          this.updateLogin();
          // 跳转管理后台
          this.$router.replace("/admin");
        },
        (error) => {
          console.log("login error:", error);
          this.logining = false;
        }
      );
    },
    sendSmsCode() {
      // console.log('smsForm:', this.smsForm)
      if (this.smsForm.mobile.length !== 11) {
        this.$message.error(this.$t("mobileOrCodeError"));
        return;
      }
      this.sending = true;
      https.sendSmsCode(
        this.smsForm.mobile,
        (response) => {
          // console.log('send sms code:', response)
          this.sending = false;
          if (response.status_code === 200) {
            if (response.data.exist) {
              this.$message({
                message: this.$t("sendSmsCodeSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: "手机号不存在，请先注册",
                type: "error",
              });
            }
          }
        },
        (error) => {
          console.log("login error:", error);
          this.sending = false;
        }
      );
    },
    handleRegister() {
      // this.$router.replace('/register')
      let registerUrl = "https://www.weikefu.net/admin/#/antv/user/register";
      if (this.electron) {
        ipcRenderer.send("open-external-url", registerUrl);
      } else {
        window.open(registerUrl);
      }
    },
    handleDownload() {
      // 在浏览器打开管理后台充值地址
      let downloadUrl = "https://www.weikefu.net/pages/download.html#downloadkefu";
      if (this.electron) {
        ipcRenderer.send("open-external-url", downloadUrl);
      } else {
        window.open(downloadUrl);
      }
    },
    qrcode() {
      this.$router.replace("/qrcode");
    },
    onLangChange(value) {
      console.log("lang:", value);
      if (value === "中文") {
        this.$i18n.locale = "zh";
        Vue.ls.set(constants.I18N, "zh");
        localStorage.i18n = "zh";
      } else {
        this.$i18n.locale = "en";
        Vue.ls.set(constants.I18N, "en");
        localStorage.i18n = "en";
      }
    },
  },
  mounted() {
    // 用户名或密码错误
    bus.$on(constants.EVENT_BUS_LOGIN_ERROR_400, (message) => {
      this.is400 = true;
      this.errorCode = 400;
      this.$message.error(this.$t("usernameOrPasswordError"));
    });
    //
    bus.$on(constants.EVENT_BUS_LOGIN_TIMEOUT, (message) => {
      this.$message.error(this.$t("timeoutCheck"));
    });
    //
    bus.$on(constants.EVENT_BUS_SERVER_ERROR_500, (message) => {
      this.errorCode = 500;
      this.$message.error(this.$t("serverError"));
    });
  },
  created() {
    let locale = Vue.ls.get(constants.I18N, constants.I18N_DEFAULT_LOCAL);
    if (locale === "zh") {
      this.currentLang = "中文";
    } else {
      this.currentLang = "English";
    }
    // 如果之前记住密码，则可以加载出来
    this.loginForm.sub_domain = Vue.ls.get(constants.SUBDOMAIN);
    this.loginForm.email = Vue.ls.get(constants.EMAIL);
    this.loginForm.password = Vue.ls.get(constants.PASSWORD);
  },
};
</script>

<style scoped>
#bd-login {
  margin-top: 50px;
}
.grid-content {
  min-height: 36px;
}
.top {
  text-align: center;
}
.header {
  height: 44px;
  line-height: 44px;
}
.badge {
  position: absolute;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  margin-left: -12px;
  margin-top: -10px;
  opacity: 0.8;
}

.vlogo {
  height: 44px;
  vertical-align: top;
  margin-right: 16px;
  border-style: none;
}
.title {
  font-size: 33px;
  color: rgba(0, 0, 0, 0.85);
  font-family: Avenir, "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: 600;
  position: relative;
  top: 2px;
}
.desc {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 12px;
  margin-bottom: 20px;
}
</style>
